
import { Translation, ProductItem } from './types';

export const PRODUCTS: ProductItem[] = [
  {
    id: 'aws',
    name: 'Amazon AWS',
    discount: '40%',
    description: 'Buy verified AWS accounts with high limits. EC2, S3, and RDS ready for enterprise use.',
    color: 'from-orange-400 to-orange-600',
    logoChar: 'A'
  },
  {
    id: 'azure',
    name: 'Microsoft Azure',
    discount: '35%',
    description: 'Verified Azure accounts. Enterprise grade subscriptions with Pay-as-you-go enabled.',
    color: 'from-blue-400 to-blue-600',
    logoChar: 'M'
  },
  {
    id: 'gcp',
    name: 'Google Cloud (GCP)',
    discount: '38%',
    description: 'Verified GCP accounts with $300+ credits. Instant access to Google Cloud Console.',
    color: 'from-red-400 to-yellow-500',
    logoChar: 'G'
  },
  {
    id: 'cloudflare',
    name: 'Cloudflare',
    discount: '30%',
    description: 'Cloudflare Enterprise plans. Anti-DDoS and Edge Workers for global performance.',
    color: 'from-orange-500 to-yellow-600',
    logoChar: 'Cf'
  },
  {
    id: 'aliyun',
    name: 'Aliyun (Alibaba Cloud)',
    discount: '30%',
    description: 'Best Aliyun seller for international accounts. Optimized for mainland China connectivity.',
    color: 'from-orange-500 to-red-600',
    logoChar: 'Al'
  },
  {
    id: 'tencent',
    name: 'Tencent Cloud',
    discount: '30%',
    description: 'Tencent Cloud accounts for gaming and low-latency Asia-Pacific infrastructure.',
    color: 'from-blue-500 to-cyan-500',
    logoChar: 'T'
  },
  {
    id: 'huawei',
    name: 'Huawei Cloud',
    discount: '25%',
    description: 'Verified Huawei Cloud accounts for high-performance enterprise compute nodes.',
    color: 'from-red-500 to-pink-600',
    logoChar: 'H'
  },
  {
    id: 'bytedance',
    name: 'Volcengine (ByteDance)',
    discount: '20%',
    description: 'Verified Volcengine accounts. Experience the power behind TikTok and Douyin.',
    color: 'from-purple-500 to-indigo-600',
    logoChar: 'V'
  }
];

export const CONTENT: Record<'en' | 'cn', Translation> = {
  en: {
    nav: {
      home: 'Home',
      products: 'AWS & Aliyun Products',
      features: 'No KYC Benefits',
      contact: 'Contact Support',
      aiAssistant: 'Cloud AI'
    },
    hero: {
      title: 'Verified AWS, Aliyun, Azure & GCP Account Seller | No KYC',
      subtitle: 'Official Reseller for Amazon AWS, Microsoft Azure, Google Cloud (GCP), and Aliyun. Get premium enterprise accounts with 40% OFF. Secure crypto payments and instant delivery for global cloud services.',
      cta: 'Buy Now on Telegram',
      secureBadge: 'Secure Verified Cloud Accounts - 100% Anonymous'
    },
    features: {
      title: 'Why CloudResell Pro is the Best AWS & Aliyun Seller',
      items: [
        {
          title: 'Verified No KYC Cloud',
          desc: 'Get fully verified AWS and Aliyun accounts without personal identification. Your privacy is our priority.',
          icon: 'shield'
        },
        {
          title: 'USDT/BTC Cloud Payments',
          desc: 'We are a crypto-friendly reseller. Pay for AWS, Azure, and GCP using USDT or Bitcoin instantly.',
          icon: 'bitcoin'
        },
        {
          title: 'Bulk Discount Pricing',
          desc: 'Save up to 40% on standard cloud rates. Best price guaranteed for AWS and Google Cloud bulk orders.',
          icon: 'percent'
        },
        {
          title: 'Clean IP & Safe Access',
          desc: 'All accounts are provisioned with clean residential IPs to prevent bans and ensure stability.',
          icon: 'lock'
        }
      ]
    },
    products: {
      title: 'Discounted AWS, Aliyun & GCP Accounts',
      subtitle: 'Explore our catalog of verified cloud accounts. We are the trusted choice for professional cloud reselling.',
      list: PRODUCTS
    },
    contact: {
      title: 'Contact the #1 Cloud Reseller',
      desc: 'Connect with our team on Telegram for bulk discounts on AWS and Aliyun accounts or custom cloud solutions.',
      telegramParams: 'Contact Support'
    },
    ai: {
      welcome: 'Hi! Looking for the best AWS, Aliyun, or GCP accounts? I can help you find the right discounted cloud solution. What do you need today?',
      placeholder: 'Ask about AWS pricing, Aliyun regions, etc.',
      send: 'Send',
      thinking: 'Analyzing Cloud Options...'
    }
  },
  cn: {
    nav: {
      home: '首页',
      products: 'AWS & 阿里云产品',
      features: '免实名优势',
      contact: '联系客服',
      aiAssistant: 'AI 顾问'
    },
    hero: {
      title: '专业 AWS, 阿里云 (Aliyun), GCP 现号分销商 | 免实名 No KYC',
      subtitle: '官方授权分销 AWS, Azure, Google Cloud, 阿里云国际版企业现号. 全球顶级公有云免实名 (No KYC), 最高 40% 优惠. 支持 USDT 支付, 即时交付。',
      cta: 'Telegram 立即咨询',
      secureBadge: '100% 匿名 & 安全 verified 现号直供'
    },
    features: {
      title: '为什么选择 CloudResell Pro 购买 AWS 与 阿里云?',
      items: [
        {
          title: '免实名认证 (No KYC)',
          desc: '无需个人身份信息 (KYC)。我们提供现成已验证的 AWS, Aliyun, GCP 企业账户，即买即用。',
          icon: 'shield'
        },
        {
          title: '加密货币支付',
          desc: '支持 USDT (TRC20/ERC20) 和 BTC 支付。安全匿名地结算您的云服务费用。',
          icon: 'bitcoin'
        },
        {
          title: '超高分销折扣',
          desc: '官方定价 6-8 折优惠。购买 AWS 预充值或 Azure 现号可享全网最低价。',
          icon: 'percent'
        },
        {
          title: '高稳定安全性',
          desc: '账户采用独享 IP 和正规支付卡创建，确保账户长期稳定运行，不封号。',
          icon: 'lock'
        }
      ]
    },
    products: {
      title: 'AWS, Aliyun, Azure 优惠现号列表',
      subtitle: '精选全球主流公有云平台（AWS, Azure, Google Cloud, Aliyun），高配现号，极速开通。',
      list: PRODUCTS
    },
    contact: {
      title: '联系全球顶级云服务分销商',
      desc: '立即通过 Telegram 联系我们，获取 AWS, 阿里云大客户折扣或定制化云端解决方案。',
      telegramParams: '联系客服'
    },
    ai: {
      welcome: '你好！正在寻找最便宜的 AWS、阿里云或 GCP 账号吗？我可以为您提供详细的价格和厂商对比建议。',
      placeholder: '咨询关于 AWS 价格、阿里云区域等...',
      send: '发送',
      thinking: '正在分析云产品数据...'
    }
  }
};
